export function principal(state) {
  return state.principal;
}
